var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const AngleDoubleLeft = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-angle_double_left ${className}`} {...other}>
      <g>
        <path d="M8.575 2.4l-4.2 5.601 4.2 5.599a.25.25 0 01-.2.4h-1.25a.5.5 0 01-.4-.2l-4.35-5.799L6.726 2.2a.5.5 0 01.4-.2h1.249a.25.25 0 01.2.4zm5 0l-4.2 5.601 4.2 5.599a.25.25 0 01-.2.4h-1.25a.5.5 0 01-.4-.2l-4.35-5.799L11.726 2.2a.5.5 0 01.4-.2h1.249a.25.25 0 01.2.4z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default AngleDoubleLeft;
